import { useMemo } from 'react';
import * as S from './MinimumVersionSection.styled';
import { CustomAutocomplete } from 'components';
import { useSelector, useDispatch } from 'react-redux';
import { select_current_min_version, select_os_min_versions } from 'store/selectors';
import { generalActions } from 'store/actions';

const MinimumVersionSection = () => {
  const dispatch = useDispatch();
  const current_min_version = useSelector(select_current_min_version);

  const all_versions = useSelector(select_os_min_versions);

  const current_min_v_obj = useMemo(
    () => all_versions?.find((item) => item.value === current_min_version),
    [all_versions, current_min_version],
  );

  const handleSelect = ({ value }) => {
    dispatch(
      generalActions.updateCurrentCampaignObj({
        propField: 'userAgentsOSMinVer',
        newValue: value,
      }),
    );
    dispatch(generalActions.setMinBidAsNotRelevant());
  };
  return (
    <S.Container>
      <S.Label>Minimum Version:</S.Label>
      <CustomAutocomplete
        withLabel
        id='minimum-version'
        defaultValue={current_min_v_obj}
        width={86}
        options={all_versions}
        onChange={handleSelect}
      />
    </S.Container>
  );
};

export default MinimumVersionSection;
